<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  beforeCreate() {
    //TODO move that to proper user state management
    if (!localStorage.gigMap) {
      localStorage.gigMap = JSON.stringify({});
    }
  },
}
</script>

<style>
html, body {
  height: 100%;
}
button {
  cursor: pointer;
}
#app {
  min-height: 100%;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  background-image: url("./assets/bg-pattern.png");
  background-size: 100%;
  background-repeat: repeat;
}
</style>
